/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { Point } from '../../../platform/geom/Point';

const Mount = styled.div<{ show?: boolean }>`
    position: absolute;
    inset: 0;
    transform: ${p => p.show ? 'scale(1)' : 'scale(0)'};
    opacity: ${p => p.show ? 1 : 0};

    transition:
        opacity 200ms ease-out,
        transform 200ms cubic-bezier(0, .99, .2, 1.14);

    svg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;

const Colors = {
    m1: { border: '#fcd52c', background: '#d5a614', shadow: '#d5a614', font: '#a57a19' },
    m2: { border: '#a7bbc9', background: '#7692a3', shadow: '#7692a3', font: '#526460' },
    m3: { border: '#f97f2d', background: '#b7501c', shadow: '#b7501c', font: '#933d16' },
    mx: { border: '#3b65ef', background: '#ffffff', shadow: '#274eba', font: 'rgb(39, 78, 186, 0.6)' },
};

class Medal extends React.Component<{ value: number, size?: number }> {

    get value() {
        return this.props.value < 0 ? 1 : this.props.value;
    }

    get key() {
        return 'm' + (this.value > 3 ? 'x' : this.value);
    }

    get colors() {
        return Colors[this.key];
    }

    get mergedProps() {
        // const width = !!size ? (size / 10) + 'rem' : undefined;
        // const height = !!size ? (size / 10) + 'rem' : undefined;
        return Object.assign({}, this.props, {
            size: undefined,
            stance: undefined,
            className: ['medal', '--m' + (this.value > 3 ? 'x' : this.value)].join(' ').trim(),
            // style: Object.assign({}, { width, height }, style),
        });
    }

    public render() {
        const { border, background, shadow, font } = this.colors;
        const fontSize = this.value === 1 ? 86 : (this.value > 9 ? 60 : 80);
        return <svg xmlns="http://www.w3.org/2000/svg" width={this.props.size} height={this.props.size} viewBox="0 0 178 178">
            <circle cx="90" cy="93" r="84" fill={shadow} />
            <circle cx="88" cy="85" r="84" fill={border} />
            <circle cx="88" cy="85" r="68" fill={background} />
            {this.value < 4 && <path fill="#fff" d="M12 85a59.8 59.8 0 0 1 1.4-22.6A64.5 64.5 0 0 1 17 51.6a66.6 66.6 0 0 1 31-32.8 58.5 58.5 0 0 1 10.6-4c-3.2 2-6.3 4-9.3 6.2a99.8 99.8 0 0 0-8.5 6.9 90.4 90.4 0 0 0-14 16.4 84.4 84.4 0 0 0-5.5 9.3L20.2 56l-1 2.5q-1.2 2.5-2 5A105.4 105.4 0 0 0 12 85z" opacity=".7" />}
            <text x="91" y="89" fill={font} fontFamily="Rubik-Bold,Rubik" fontSize={fontSize} fontWeight="700" dominantBaseline="central" textAnchor="middle">
                <tspan>{this.value}</tspan><tspan fontSize={40}>{postFix(this.value)}</tspan>
            </text>
            <text x="89" y="85" fill={border} fontFamily="Rubik-Bold,Rubik" fontSize={fontSize} fontWeight="700" dominantBaseline="central" textAnchor="middle">
                <tspan>{this.value}</tspan><tspan fontSize={40}>{postFix(this.value)}</tspan>
            </text>
        </svg>;
    }
}

const postFix = value => {
    if (value % 100 === 11) return 'th';
    if (value % 100 === 12) return 'th';
    if (value % 100 === 13) return 'th';
    if (value % 10 === 1) return 'st';
    if (value % 10 === 2) return 'nd';
    if (value % 10 === 3) return 'rd';
    return 'th';
};

// eslint-disable-next-line react/display-name
export const RenderRankingMedal = React.memo<{ value: number, offset?: Point, show?: boolean }>(({ value, offset, show }) => {
    if (!value) return null;
    offset = offset ?? Point.zero;
    const ms = {
        marginLeft: `${offset.x}px`,
        marginTop: `${offset.y}px`,
    };
    return <Mount show={show} style={ms}>
        <Medal value={value} size={120} />
    </Mount>;
});
